import $ from 'jquery';
import { has } from 'lodash';
import { getCostOfBorrowing } from '../../showroom/showroom-utilities';
import { PaymentCalculatorFactory, Formatter } from '@dealersites/dealersite-js-core';

const inventoryPluginCalculatorRules = $('.featured-dsp-calculator').data('dsp-calculator');

// Setup Finance

let financeOGData = [];
let sortedYearFinanceData = [];

if (has(inventoryPluginCalculatorRules, 'finance')) {
  financeOGData = inventoryPluginCalculatorRules.finance.map((value) => {
    return {
      year_min: value.year_min,
      year_max: value.year_max,
      term_min: value.term_min,
      term_max: value.term_max,
      rate: Math.abs(parseFloat(value.rate)),
    };
  });

  let sortedRateFinanceData = financeOGData.sort((a, b) => (a.rate < b.rate ? 1 : -1));
  sortedYearFinanceData = sortedRateFinanceData.sort((a, b) => (a.year_min < b.year_min ? 1 : -1));
}

// Setup Lease
let leaseOGData = [];
let sortedYearLeaseData = [];

if (has(inventoryPluginCalculatorRules, 'lease')) {
  leaseOGData = inventoryPluginCalculatorRules.lease.map((value) => {
    return {
      year_min: value.year_min,
      year_max: value.year_max,
      term_min: value.term_min,
      term_max: value.term_max,
      residual: parseInt(value.residual),
      rate: Math.abs(parseFloat(value.rate)),
    };
  });

  let sortedRateLeaseData = leaseOGData.sort((a, b) => (a.rate < b.rate ? 1 : -1));
  sortedYearLeaseData = sortedRateLeaseData.sort((a, b) => (a.year_min < b.year_min ? 1 : -1));
}

export function dspFinance(item, disclaimer) {
  const finance = [];
  const months = [];

  sortedYearFinanceData.forEach((value) => {
    if (item.year <= value.year_max && item.year >= value.year_min) {
      for (let i = value.term_min; i <= value.term_max; i += 12) {
        const financeValue = {
          from: i,
          to: i,
          rate: parseFloat(value.rate),
        };
        if (!months.includes(i)) {
          finance.push(financeValue);
          months.push(i);
        }
      }
    }
  });

  const financeData = finance.sort((a, b) => (a.from < b.from ? 1 : -1));
  const financeDefault = financeData[0];

  if (financeDefault) {
    let calcInputs = {
      price: item.lowest_price,
      down: 0,
      term: financeDefault.from,
      rate: financeDefault.rate,
      tradein: 0,
      tax: disclaimer.adjustPayments ? disclaimer.tax : 0,
    };

    return dspCalculatePayment(calcInputs, 'finance');
  } else {
    return '--';
  }
}

export function dspLease(item, disclaimer) {
  const lease = [];
  const months = [];

  sortedYearLeaseData.forEach((value) => {
    if (item.year <= value.year_max && item.year >= value.year_min) {
      for (let i = value.term_min; i <= value.term_max; i += 12) {
        const leaseValue = {
          from: i,
          to: i,
          rate: parseFloat(value.rate),
          residualValue: item.price * (value.residual / 100),
        };
        if (!months.includes(i)) {
          lease.push(leaseValue);
          months.push(i);
        }
      }
    }
  });

  const leaseData = lease.sort((a, b) => (a.from < b.from ? 1 : -1));

  const leaseDefault = leaseData[0];

  if (leaseDefault) {
    let calcInputs = {
      price: item.lowest_price,
      down: 0,
      term: leaseDefault.from,
      rate: leaseDefault.rate,
      tradein: 0,
      tax: disclaimer.adjustPayments ? disclaimer.tax : 0,
      residual: leaseDefault.residualValue,
    };
    return dspCalculatePayment(calcInputs, 'lease');
  } else {
    return '--';
  }
}

export function dspCalculatePayment(calcInputs, calculatorType, frequency = 'biweekly') {
  let payment = '--';
  if (['finance', 'lease'].includes(calculatorType)) {
    const newCalc = PaymentCalculatorFactory.createCalculator(calculatorType, calcInputs);

    newCalc.calculate();
    payment = newCalc.payments[frequency];
  }
  return payment;
}

$('.dsp-payment-calculate').each(function (index) {
  let $payment = $(this);
  const cob = $payment.data('cob');

  let calcInputs = {
    price: $payment.data('price'),
    down: $payment.data('down'),
    term: $payment.data('term'),
    rate: $payment.data('rate'),
    tradein: $payment.data('tradein'),
  };

  const calculatorType = $payment.data('type');
  const includeTax = $payment.data('include-tax');
  const tax = parseInt($payment.data('tax'));
  const frequency = $payment.data('frequency') ?? 'biweekly';

  calcInputs.tax = includeTax ? tax : 0;

  if (calculatorType === 'lease') {
    calcInputs.residual = $payment.data('residual');
  }

  const payment = dspCalculatePayment(calcInputs, calculatorType, frequency);
  $payment.text(`${Formatter.price(payment, 0)}`);

  if (cob) {
    const $cobElem = $payment.closest('.dsp-payment').find('.dsp-cob');
    const paymentCOB = getCostOfBorrowing({
      payment: payment,
      term: calcInputs.term,
      frequency: frequency,
      price: calcInputs.price - (calculatorType == 'lease' ? calcInputs.residual : 0),
    });
    $cobElem.text(Formatter.price(paymentCOB), 2);
  }
});
